
ACC.paymenttype = {
  spinner: 'ph-spinnerorder',
  bindAll: function() {
    this.bindToPurchaseOrderNumberInput();
    this.bindToDeliveryAttentionNameInput();
    this.bindToDeliveryPhoneInput();
    this.bindToDeliveryInstruction();
    $('#cignumber').on('keyup', ACC.paymenttype.validateCIGNumber);
    this.bindToCIGNumberInput();
    setTimeout(function() {
      ACC.paymenttype.triggerAtpMinicart();
    }, 500);
  },
  triggerAtpMinicart: function() {
    if ($('.triggerAtpMinicart').length > 0 && $('.triggerAtpMinicart').text() === 'true') {
      if ($('.rollover_cart_popup:visible').length === 0) {
        $('.ph-headerparent__minicartdata').trigger('click');
      }
    }
  },

  validateCIGNumber: function(evt) {
    var event = evt || window.event,
        val = event.target.value,
        filtered = val.replace(/[^A-Za-z0-9]/g, '');

    if (filtered !== val) {
      event.target.value = filtered;
    }
  },
  addGoldenOppurtunity: function() {
    var goldenoppnum = '';

    goldenoppnum = $('#goldenOppNumber').val();

    return goldenoppnum;
  },
  setPaymentType: function() {
    var paymentTypeSelected = $('input:radio[name=\'PaymentType\']:checked').val();

    $('#checkout_summary_paymentType_div').removeClass('complete');

    if (paymentTypeSelected) {
      $.postJSON(ACC.config.contextPath + $('.ph-setPaymentTypeURL').text(), {
        paymentType: paymentTypeSelected
      }, ACC.paymenttype.summaryFlowAfterPaymentTypeSetSuccess);
    }
  },

  bindToPurchaseOrderNumberInput: function() {
    $(document).on('blur', '#PurchaseOrderNumber', function() {
      $('.' + ACC.paymenttype.spinner).removeClass('hidden');

      var purchaseOrderNumber = $('input[name=\'PurchaseOrderNumber\']').val();

      ACC.paymenttype.checkPONumberEmptyValue();


      $.postJSON(ACC.config.contextPath + $('.ph-setPurchaseOrderNumberURL').text(), {
        purchaseOrderNumber: purchaseOrderNumber
      }, ACC.paymenttype.summaryFlowAfterInputValueSetSuccess);
    });
  },

  bindToCIGNumberInput: function() {
    $('#cignumber').focusout(function() {
      $('.' + ACC.paymenttype.spinner).removeClass('hidden');

      var cigNumber = $('input[name=\'cignumber\']').val();

      $.postJSON(ACC.config.contextPath + $('.ph-setCigNumberURL').text(), {
        cigNumber: cigNumber
      }, ACC.paymenttype.summaryFlowAfterInputValueSetSuccess);
    });
  },

  bindToDeliveryAttentionNameInput: function() {
    $('#deliveryAttention').focusout(function() {
      var deliveryAttention = $('input[name=\'deliveryAttention\']').val();

      $.postJSON(ACC.config.contextPath + $('.ph-setAttentionNameURL').text(), {
        deliveryAttention: deliveryAttention
      }, ACC.paymenttype.summaryFlowAfterInputValueSetSuccess);
    });
  },
  bindToDeliveryPhoneInput: function() {
    $('#deliveryPhone').focusout(function() {
      var deliveryPhone = $('input[name=\'deliveryPhone\']').val();

      $.postJSON(ACC.config.contextPath + $('.ph-setAttentionPhoneURL').text(), {
        deliveryPhone: deliveryPhone
      }, ACC.paymenttype.summaryFlowAfterInputValueSetSuccess);
    });
  },
  bindToDeliveryInstruction: function() {
    $('#spsDeliveryInstruction').focusout(function() {
      var spsDeliveryInstruction = $(this).val();

      $.postJSON(ACC.config.contextPath + $('.ph-setInstructionURL').text(), {
        spsDeliveryInstruction: spsDeliveryInstruction
      }, $('.' + ACC.paymenttype.spinner).addClass('hidden'));
    });
  },
  summaryFlowAfterInputValueSetSuccess: function(checkoutCartData) {
    ACC.paymenttype.markPaymentTypeSectionAsCompleted(checkoutCartData);
    ACC.placeorder.updatePlaceOrderButton();
    $('.' + ACC.paymenttype.spinner).addClass('hidden');
  },

  summaryFlowAfterPaymentTypeSetSuccess: function(checkoutCartData) {
    ACC.paymenttype.markPaymentTypeSectionAsCompleted(checkoutCartData);
    ACC.paymenttype.hideAndShowRequiredDiv(checkoutCartData);
    ACC.paymenttype.hideAndShowRequiredDivOneStore(checkoutCartData);
    ACC.placeorder.updatePlaceOrderButton();
  },
  checkPONumberEmptyValue: function() {
    var poMandatory = $('.ph-poNumberMandatory').html(),
        inputValue = $('#PurchaseOrderNumber').val(),
        poInputCheck = true;

    if (!inputValue && poMandatory === 'true') {
      $('.errorPOnumber').removeClass('hidden');
      $('.ph-poNumber').addClass('ph-form_field_error ph-form__fieldwrap');

      if ($('#PurchaseOrderNumber').length > 0) {
        $('html,body').animate({
          scrollTop: $('#PurchaseOrderNumber').offset().top - 50
        }, 'slow');
      }

      poInputCheck = false;
    } else {
      $('.errorPOnumber').addClass('hidden');
      $('.ph-poNumber').removeClass('ph-form_field_error ph-form__fieldwrap');
    }

    return poInputCheck;
  },
  /* eslint-disable complexity */
  summaryFlowAfterPurchaseOrderNumberSuccess: function(checkoutCartData) {
    /* eslint-enable complexity */
    var showAttentionFields = $('.ph-showAttentionFields').text();

    if (showAttentionFields === 'true') {
      if ($('input:radio[name=\'PaymentType\']:checked').val() !== '' && checkoutCartData.purchaseOrderNumber !== null && $.trim(checkoutCartData.purchaseOrderNumber) !== '' && checkoutCartData.deliveryAttention !== null && $.trim(checkoutCartData.deliveryAttention) !== '' && checkoutCartData.deliveryPhone !== null && $.trim(checkoutCartData.deliveryPhone) !== '') {
        $('#checkout_summary_paymentType_div').addClass('complete');
      } else {
        $('#checkout_summary_paymentType_div').removeClass('complete');
      }
    } else if ($('input:radio[name=\'PaymentType\']:checked').val() !== '' && checkoutCartData.purchaseOrderNumber !== null && $.trim(checkoutCartData.purchaseOrderNumber) !== '') {
      $('#checkout_summary_paymentType_div').addClass('complete');
    } else {
      $('#checkout_summary_paymentType_div').removeClass('complete');
    }
  },
  /* eslint-disable  complexity */
  markPaymentTypeSectionAsCompleted: function(checkoutCartData) {
    /* eslint-enable  complexity */
    var showAttentionFields = $('.ph-showAttentionFields').text();

    if (showAttentionFields === 'true') {
      if ($('input:radio[name=\'PaymentType\']:checked').val() !== '' && checkoutCartData.purchaseOrderNumber !== null && $.trim(checkoutCartData.purchaseOrderNumber) !== '' && checkoutCartData.deliveryAttention !== null && $.trim(checkoutCartData.deliveryAttention) !== '' && checkoutCartData.deliveryPhone !== null && $.trim(checkoutCartData.deliveryPhone) !== '') {
        $('#checkout_summary_paymentType_div').addClass('complete');
      } else if ($('input:radio[name=\'PaymentType\']:checked').val() !== '' && $('#PurchaseOrderNumber').val() !== '' && $('#deliveryAttention').val() !== '' && $('#deliveryPhone').val() !== '') {
        $('#checkout_summary_paymentType_div').addClass('complete');
      } else {
        $('#checkout_summary_paymentType_div').removeClass('complete');
      }
    } else if ($('input:radio[name=\'PaymentType\']:checked').val() !== '' && checkoutCartData.purchaseOrderNumber !== null && $.trim(checkoutCartData.purchaseOrderNumber) !== '') {
      $('#checkout_summary_paymentType_div').addClass('complete');
    } else {
      $('#checkout_summary_paymentType_div').removeClass('complete');
    }
  },

  hideAndShowRequiredDiv: function(paymentType) {
    if (paymentType === 'CARD') {
      $('div.checkout_summary_flow').removeClass('cardtype').addClass('cardtype');
      $('#checkout_summary_payment_div').removeClass('hidden');
      $('#scheduleReplenishmentButton').addClass('disabled');
      $('#checkout_summary_costcenter_div').hide();
      $('#checkout_summary_payment_div').show();
      $('.ph-checkoutbilling-address').hide();
      $('.ph-checkoutpayee-address').hide();
      $('#checkout_summary_accountpayment_div').hide();
    } else {
      $('div.checkout_summary_flow').removeClass('cardtype');
      $('#checkout_summary_payment_div').hide();
      $('#checkout_summary_costcenter_div').show();
      $('.ph-checkoutbilling-address').show();
      $('.ph-checkoutpayee-address').show();
      $('#scheduleReplenishmentButton').removeClass('disabled');
      $('#checkout_summary_accountpayment_div').show();
    }
  },
  hideAndShowRequiredDivOneStore: function(paymentType) {
    if (paymentType === 'CARD') {
      $('.ph-billingAddressError, .ph-payeeAddressError').addClass('hiddenClass');
      $('.ph-ch_payment-addr_payee').addClass('hidden');
      $('.ph-ch_payment-addr_billing').addClass('hidden');
      $('.ph-checkout_completepurchase').addClass('hidden');
      $('.ph-checkout_paynowButton').removeClass('hidden');
    } else {
      $('.ph-ch_payment-addr_payee').removeClass('hidden');
      $('.ph-ch_payment-addr_billing').removeClass('hidden');
      $('.ph-checkout_completepurchase').removeClass('hidden');
      $('.ph-checkout_paynowButton').addClass('hidden');
    }

    if (paymentType === 'FINANCE' && $(document).find('.ph-radiocontainer .ph-paymentmode:visible').length > 0) {
      $('.ph-paymentpagefinaceMessageBox').removeClass('hidden');
    } else {
      $('.ph-paymentpagefinaceMessageBox').addClass('hidden');
    }
  }

};

$(document).ready(function() {
  ACC.paymenttype.bindAll();

  if ($('#showDebugPage').length <= 0) {
    $('#hostedOrderPagePostForm').submit();
  }

  $(document).on('change', '#fileToUpload', function() {
    var file = $('#fileToUpload')[0].files[0].name;

    $('.ph-vatexception_choosetext').html(file);
  });
});
